<script>
  import { fade } from "svelte/transition";

  import { modalActive } from "../../stores/global.js";

  export let size = 20;
  export let fill = "white";
  export let style = "";
  export let inOnboard = false;
</script>

<svg
  transition:fade
  on:click={inOnboard
    ? null
    : () => {
        modalActive.set(true);
      }}
  height={size}
  width={size}
  {fill}
  pointer-events="bounding-box"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  version="1.1"
  x="0px"
  y="0px"
  viewBox="0 0 100 100"
  style="enable-background:new 0 0 100 100; {style}"
  ><path
    d="M50.3,98.1C23.6,98.1,2,76.4,2,49.8S23.6,1.5,50.3,1.5s48.3,21.7,48.3,48.3S76.9,98.1,50.3,98.1z M50.3,7.4  C26.9,7.4,8,26.4,8,49.8c0,23.3,19,42.3,42.3,42.3c23.3,0,42.3-19,42.3-42.3C92.6,26.4,73.6,7.4,50.3,7.4z"
  /><path
    d="M50.8,24.1c-9.1,0-16.6,7.4-16.6,16.6c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7c0-6.2,5-11.2,11.2-11.2  S62,34.5,62,40.7s-5,11.2-11.2,11.2c-1.5,0-2.7,1.2-2.7,2.7v8.1c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7V57  c7.9-1.3,13.9-8.1,13.9-16.4C67.4,31.5,60,24.1,50.8,24.1z"
  /><circle cx="50.8" cy="73.6" r="3.8" />
</svg>

<style>
  svg {
    position: absolute;
    bottom: 30px;
    left: 2.5%;
    z-index: 10;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    svg {
      left: 4%;
      top: 4%;
    }
  }
</style>
